/*
  Custom Announcement Bar — Pause Rituals
  Mobile only (<=749px): rotates one announcement at a time, supports swipe, and
  pauses while the user is interacting. Desktop shows all items via CSS (no JS needed).
  Safe to call twice; re-inits on Shopify section load (theme editor).
*/
(function () {
  function init(root) {
    (root || document).querySelectorAll('.cab').forEach(setup);
  }

  function setup(cab) {
    if (cab.dataset.cabReady === '1') return;
    cab.dataset.cabReady = '1';

    var items = Array.prototype.slice.call(cab.querySelectorAll('.cab__item'));
    if (items.length < 2) return;

    var mq = window.matchMedia('(max-width: 749px)');
    var speed = parseInt(cab.dataset.speed, 10) || 3000;
    var auto = cab.dataset.autorotate === 'true';
    var current = 0;
    var timer = null;

    function resetWaiting(el) {
      // snap the item back to its "waiting" state (below the mask) WITHOUT animating
      // through the visible window, so it can roll up cleanly next time.
      el.classList.add('cab-no-anim');
      el.classList.remove('is-active', 'is-leaving');
      void el.offsetWidth; // force reflow so the snap applies before re-enabling transitions
      el.classList.remove('cab-no-anim');
    }

    function show(i) {
      var prev = current;
      var n = (i + items.length) % items.length;
      if (n === prev) return;
      var leaving = items[prev];
      var entering = items[n];
      // outgoing rolls up & out; incoming rolls up from below into the window
      leaving.classList.remove('is-active');
      leaving.classList.add('is-leaving');
      entering.classList.remove('is-leaving', 'cab-no-anim');
      entering.classList.add('is-active');
      current = n;
      window.setTimeout(function () { resetWaiting(leaving); }, 850);
    }
    function next() { show(current + 1); }
    function prev() { show(current - 1); }

    function start() {
      stop();
      if (auto && mq.matches) timer = setInterval(next, speed);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    // swipe (pause while touching, resume after)
    var x0 = null;
    cab.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX;
      stop();
    }, { passive: true });
    cab.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); }
      x0 = null;
      start();
    }, { passive: true });

    // pause on hover/focus too
    cab.addEventListener('mouseenter', stop);
    cab.addEventListener('mouseleave', start);
    cab.addEventListener('focusin', stop);
    cab.addEventListener('focusout', start);

    // start/stop when crossing the mobile breakpoint
    var onChange = function () { mq.matches ? start() : stop(); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);

    start();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
